<template>
  <section class="not-found">
    <div class="container not-found__inner">
      <p class="not-found__code">404</p>
      <h1 class="not-found__title">页面未找到</h1>
      <p class="not-found__desc">您访问的页面不存在或已被移除，请返回首页继续浏览。</p>
      <div class="not-found__actions">
        <router-link to="/" class="not-found__btn not-found__btn--primary">返回首页</router-link>
        <router-link to="/products" class="not-found__btn">查看产品</router-link>
      </div>
      <ul class="not-found__links">
        <li v-for="p in products" :key="p.id">
          <router-link v-if="p.route" :to="p.route">{{ p.title }}</router-link>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { products } from '../data/site'

export default {
  name: 'NotFound',
  data() {
    return { products }
  }
}
</script>

<style scoped>
.not-found {
  min-height: 60vh;
  display: flex;
  align-items: center;
  padding: 80px 0;
}

.not-found__inner {
  text-align: center;
  max-width: 560px;
}

.not-found__code {
  font-size: 72px;
  font-weight: 800;
  line-height: 1;
  color: #0052d9;
  margin-bottom: 16px;
}

.not-found__title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 12px;
}

.not-found__desc {
  font-size: 15px;
  color: #666;
  line-height: 1.7;
  margin-bottom: 28px;
}

.not-found__actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 32px;
}

.not-found__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid #d9d9d9;
  color: #333;
  transition: all 0.2s;
}

.not-found__btn--primary {
  background: #0052d9;
  border-color: #0052d9;
  color: #fff;
}

.not-found__btn--primary:hover {
  background: #003cab;
}

.not-found__btn:hover {
  border-color: #0052d9;
  color: #0052d9;
}

.not-found__links {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 20px;
  justify-content: center;
  font-size: 13px;
}

.not-found__links a {
  color: #0052d9;
}

.not-found__links a:hover {
  text-decoration: underline;
}
</style>
